<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="员工姓名"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.status" placeholder="状态" class="filter-item" style="width: 120px;" clearable>
        <el-option label="在职" :value="1" />
        <el-option label="离职" :value="0" />
      </el-select>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        v-hasPermi="['system:employee:add']"
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >
        添加
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="姓名" min-width="100" align="center">
        <template slot-scope="{row}">
          <span>{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="性别" width="80" align="center">
        <template slot-scope="{row}">
          <span>{{ row.gender }}</span>
        </template>
      </el-table-column>
      <el-table-column label="年龄" width="80" align="center">
        <template slot-scope="{row}">
          <span>{{ row.age }}</span>
        </template>
      </el-table-column>
      <el-table-column label="电话" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="入职日期" width="120" align="center">
        <template slot-scope="{row}">
          <span>{{ row.hireDate | parseTime('{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门" min-width="160" align="center">
        <template slot-scope="{row}">
          <span>{{ formatDepartmentNames(row.departments) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="岗位" min-width="160" align="center">
        <template slot-scope="{row}">
          <span>{{ formatStationNames(row.stations) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="关联用户" min-width="140" align="center">
        <template slot-scope="{row}">
          <span>{{ (row.user && (row.user.nickname || row.user.username)) || (row.userId ? `用户ID:${row.userId}` : '-') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" class-name="status-col" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 1 ? '在职' : '离职' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width">
        <template slot-scope="{row,$index}">
          <el-dropdown trigger="click" @command="command => handleAction(command, row, $index)">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑员工</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 0" command="employed">在职</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 1" command="resigned">离职</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" class="common-dialog">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="员工姓名" prop="name">
          <el-input v-model="temp.name" placeholder="请输入员工姓名" />
        </el-form-item>
        <el-form-item label="员工编号" prop="code">
          <el-input v-model="temp.code" placeholder="请输入员工编号" />
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="temp.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="temp.idCard" placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item label="年龄">
          <el-input-number v-model="temp.age" :min="0" :max="120" disabled />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="temp.phone" placeholder="请输入电话号码" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="temp.email" type="email" placeholder="请输入邮箱" />
        </el-form-item>
        <el-form-item label="部门">
          <el-select
            v-model="temp.departmentIds"
            multiple
            clearable
            filterable
            placeholder="请选择部门"
            style="width: 100%;"
            @change="handleDepartmentChange"
          >
            <el-option
              v-for="dept in departmentList"
              :key="dept.id"
              :label="dept.deptName || dept.name"
              :value="dept.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="岗位">
          <el-select
            v-model="temp.stationIds"
            multiple
            clearable
            filterable
            placeholder="请选择岗位"
            style="width: 100%;"
            @change="handleStationChange"
          >
            <el-option
              v-for="station in stationList"
              :key="station.id"
              :label="station.stationName"
              :value="station.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="入职日期">
          <el-date-picker
            v-model="temp.hireDate"
            type="date"
            placeholder="选择入职日期"
            format="yyyy-MM-dd"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="temp.status" class="filter-item" placeholder="请选择状态">
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.display_name" :value="item.key" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="temp.status === 0" label="离职时间" prop="leaveDate">
          <el-date-picker
            v-model="temp.leaveDate"
            type="date"
            placeholder="选择离职日期"
            format="yyyy-MM-dd"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>

    <!-- 关联用户对话框 -->
    <el-dialog title="关联用户" :visible.sync="bindUserDialogVisible" width="520px" class="common-dialog">
      <el-form :model="bindUserForm" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="员工">
          <el-input :value="bindUserForm.employeeName" disabled />
        </el-form-item>
        <el-form-item label="关联用户">
          <el-select
            v-model="bindUserForm.userId"
            filterable
            clearable
            :loading="userOptionsLoading"
            placeholder="输入用户名/姓名搜索"
            style="width: 100%;"
          >
            <el-option
              v-for="u in userOptions"
              :key="u.id"
              :label="formatUserLabel(u)"
              :value="u.id"
            />
          </el-select>
          <div style="margin-top: 6px; color: #909399; font-size: 12px;">
            说明：清空选择后点击“确认”，将解除关联。
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindUserDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="bindUserSaving" @click="saveBindUser">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getEmployeeList, getEmployeeById, createEmployee, updateEmployee, deleteEmployee, bindEmployeeUser, unbindEmployeeUser } from '../../../api/employee'
import { getAllDepartments } from '../../../api/department'
import { getAllStations } from '../../../api/station'
import { getAllUsers } from '../../../api/user'
import { parseTime } from '../../../utils/index'
import waves from '../../../directive/waves' // waves directive
import Pagination from '../../../components/Pagination' // secondary package based on el-pagination

export default {
  name: 'EmployeeTable',
  components: { Pagination },
  directives: { waves },
  filters: {
    parseTime,
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  watch: {
    'temp.idCard'(value) {
      const age = this.calculateAgeFromIdCard(value)
      if (age !== null) {
        this.temp.age = age
      }
    },
    'temp.status'(value) {
      if (value !== 0) {
        this.temp.leaveDate = ''
      }
    }
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        name: undefined,
        status: undefined
      },
      statusOptions: [
        { key: 1, display_name: '在职' },
        { key: 0, display_name: '离职' }
      ],
      departmentList: [],
      stationList: [],
      temp: {
        id: undefined,
        name: '',
        code: '',
        gender: '男',
        age: 25,
        idCard: '',
        phone: '',
        email: '',
        hireDate: '',
        leaveDate: '',
        status: 1,
        departmentIds: [],
        stationIds: []
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑员工',
        create: '创建员工'
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        name: [{ required: true, message: '员工姓名不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '员工编号不能为空', trigger: 'blur' }],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '身份证号不能为空', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{17}[\dXx]$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        leaveDate: [
          { required: true, message: '离职时间不能为空', trigger: 'change' }
        ]
      },
      bindUserDialogVisible: false,
      bindUserSaving: false,
      bindUserForm: {
        employeeId: undefined,
        employeeName: '',
        userId: null
      },
      userOptionsLoading: false,
      userOptions: [],
      downloadLoading: false
    }
  },
  created() {
    this.getList()
    this.getDepartmentList()
    this.getStationList()
  },
  methods: {
    normalizeRelationIds(list) {
      if (!Array.isArray(list)) return []
      return list
        .filter(id => id !== undefined && id !== null && id !== '')
        .map(id => String(id))
    },
    buildRelationPayload(list) {
      if (!Array.isArray(list)) return []
      return list
        .filter(id => id !== undefined && id !== null && id !== '')
        .map(id => {
          const value = Number(id)
          return Number.isNaN(value) ? id : value
        })
    },
    getDepartmentList() {
      return getAllDepartments().then(response => {
        const list = response && response.data ? response.data : []
        this.departmentList = Array.isArray(list)
          ? list.map(dept => ({
            ...dept,
            id: String(dept.id)
          }))
          : []
        return this.departmentList
      })
    },
    getStationList() {
      return getAllStations().then(response => {
        const list = response && response.data ? response.data : []
        this.stationList = Array.isArray(list)
          ? list.map(station => ({
            ...station,
            id: String(station.id)
          }))
          : []
        return this.stationList
      })
    },
    handleDepartmentChange(values) {
      this.$set(this.temp, 'departmentIds', this.normalizeRelationIds(values))
    },
    handleStationChange(values) {
      this.$set(this.temp, 'stationIds', this.normalizeRelationIds(values))
    },
    formatDepartmentNames(departments) {
      if (!Array.isArray(departments) || departments.length === 0) {
        return '-'
      }
      return departments.map(dept => dept.deptName || dept.name).filter(Boolean).join('、') || '-'
    },
    formatStationNames(stations) {
      if (!Array.isArray(stations) || stations.length === 0) {
        return '-'
      }
      return stations.map(station => station.stationName || station.name).filter(Boolean).join('、') || '-'
    },
    getList() {
      this.listLoading = true
      const data = {
        page: this.listQuery.page - 1,
        size: this.listQuery.size
      }
      if (this.listQuery.name) {
        data.name = this.listQuery.name
      }
      if (this.listQuery.status !== undefined && this.listQuery.status !== null && this.listQuery.status !== '') {
        data.status = this.listQuery.status
      }
      getEmployeeList(data).then(response => {
        this.list = response.data.content
        this.total = response.data.totalElements

        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleAction(command, row, index) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'bindUser':
          this.openBindUser(row)
          break
        case 'employed':
          this.handleModifyStatus(row, 'employed')
          break
        case 'resigned':
          this.handleModifyStatus(row, 'resigned')
          break
        case 'delete':
          this.handleDelete(row, index)
          break
        default:
          break
      }
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        name: '',
        code: '',
        gender: '男',
        age: 25,
        idCard: '',
        phone: '',
        email: '',
        hireDate: '',
        leaveDate: '',
        status: 1,
        departmentIds: [],
        stationIds: []
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const payload = Object.assign({}, this.temp)
          payload.hireDate = this.normalizeDate(payload.hireDate)
          payload.leaveDate = this.normalizeDate(payload.leaveDate)
          payload.departmentIds = this.buildRelationPayload(payload.departmentIds)
          payload.stationIds = this.buildRelationPayload(payload.stationIds)
          if (payload.status !== 0) {
            payload.leaveDate = null
          }
          createEmployee(payload).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
            
            // 如果勾选了创建关联用户，则同时创建用户
            if (this.temp.createUser) {
              // 创建用户的逻辑
            }
          })
        }
      })
    },
    handleUpdate(row) {
      const departmentIds = this.normalizeRelationIds(
        Array.isArray(row.departments)
          ? row.departments.map(dept => dept.id).filter(id => id !== undefined && id !== null)
          : []
      )
      const stationIds = this.normalizeRelationIds(
        Array.isArray(row.stations)
          ? row.stations.map(station => station.id).filter(id => id !== undefined && id !== null)
          : []
      )
      this.temp = Object.assign({}, row, {
        hireDate: this.normalizeDate(row.hireDate),
        leaveDate: this.normalizeDate(row.leaveDate),
        departmentIds,
        stationIds
      })
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    openBindUser(row) {
      this.bindUserForm = {
        employeeId: row.id,
        employeeName: row.name || row.code || String(row.id),
        userId: null
      }
      this.userOptions = []
      this.bindUserDialogVisible = true

      // 获取当前关联（以详情为准）
      getEmployeeById(row.id).then(res => {
        const data = res.data || {}
        const userId = data.userId || (data.user && data.user.id) || row.userId || null
        this.bindUserForm.userId = userId
        this.loadAllUsers()
      }).catch(() => {
        this.bindUserForm.userId = row.userId || null
        this.loadAllUsers()
      })
    },
    loadAllUsers() {
      this.userOptionsLoading = true
      getAllUsers().then(res => {
        this.userOptions = Array.isArray(res.data) ? res.data : []
        this.userOptionsLoading = false
      }).catch(() => {
        this.userOptionsLoading = false
      })
    },
    formatUserLabel(u) {
      const nickname = u.nickname ? `(${u.nickname})` : ''
      return `${u.username || ''}${nickname}`.trim() || String(u.id)
    },
    saveBindUser() {
      const employeeId = this.bindUserForm.employeeId
      const userId = this.bindUserForm.userId
      if (!employeeId) return
      this.bindUserSaving = true
      const req = userId ? bindEmployeeUser({ id: employeeId, userId }) : unbindEmployeeUser(employeeId)
      req.then(() => {
        this.bindUserSaving = false
        this.bindUserDialogVisible = false
        this.getList()
        this.$notify({
          title: '成功',
          message: userId ? '关联成功' : '已解除关联',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        this.bindUserSaving = false
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          tempData.hireDate = this.normalizeDate(tempData.hireDate)
          tempData.leaveDate = this.normalizeDate(tempData.leaveDate)
          tempData.departmentIds = this.buildRelationPayload(tempData.departmentIds)
          tempData.stationIds = this.buildRelationPayload(tempData.stationIds)
          if (tempData.status !== 0) {
            tempData.leaveDate = null
          }
          updateEmployee(tempData).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleModifyStatus(row, status) {
      const statusText = status === 'employed' ? '在职' : '离职'
      const newStatus = status === 'employed' ? 1 : 0
      this.$confirm(`此操作将${statusText}该员工, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const tempData = Object.assign({}, row)
        tempData.status = newStatus
        if (newStatus !== 0) {
          tempData.leaveDate = null
        } else if (!tempData.leaveDate) {
          tempData.leaveDate = Date.now()
        }
        tempData.departmentIds = this.buildRelationPayload(
          Array.isArray(row.departments)
            ? row.departments.map(dept => dept.id)
            : []
        )
        tempData.stationIds = this.buildRelationPayload(
          Array.isArray(row.stations)
            ? row.stations.map(station => station.id)
            : []
        )
        updateEmployee(tempData).then(() => {
          this.getList()
          this.$notify({
            title: '成功',
            message: `${statusText}成功`,
            type: 'success',
            duration: 2000
          })
        })
      })
    },
    normalizeDate(value) {
      if (!value) {
        return null
      }
      if (typeof value === 'number') {
        return value
      }
      if (value instanceof Date) {
        return value.getTime()
      }
      if (typeof value === 'string') {
        const date = new Date(value)
        if (!isNaN(date.getTime())) {
          return date.getTime()
        }
      }
      return null
    },
    calculateAgeFromIdCard(idCard) {
      if (!idCard) {
        return null
      }
      const value = String(idCard).trim()
      let birth
      if (/^\d{17}[\dXx]$/.test(value)) {
        birth = value.substring(6, 14) // yyyyMMdd
      } else if (/^\d{15}$/.test(value)) {
        birth = `19${value.substring(6, 12)}` // yyMMdd -> 19yyMMdd
      } else {
        return null
      }
      const year = Number(birth.substring(0, 4))
      const month = Number(birth.substring(4, 6))
      const day = Number(birth.substring(6, 8))
      if (!year || !month || !day) {
        return null
      }
      const today = new Date()
      let age = today.getFullYear() - year
      const m = today.getMonth() + 1
      const d = today.getDate()
      if (m < month || (m === month && d < day)) {
        age -= 1
      }
      return age
    },
    handleDelete(row, index) {
      this.$confirm('此操作将永久删除该员工, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteEmployee(row.id).then(() => {
          this.list.splice(index, 1)
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    }
  }
}
</script>